import { render, staticRenderFns } from "./viewRelCabecalhoRemessa.vue?vue&type=template&id=65904781"
import script from "./viewRelCabecalhoRemessa.vue?vue&type=script&lang=ts"
export * from "./viewRelCabecalhoRemessa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports